import React from 'react';
import Layout from '../../Layout';
import PostForm from '../PostForm';
import { connect, useDispatch } from 'react-redux';
import { ADD_POST_REQUEST } from '../constant';
import { useHistory } from 'react-router';

const AddPost = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const handleSubmit = ({ form }) => {
    dispatch({
      type: ADD_POST_REQUEST,
      payload: {
        form,
        callback: success => {
          if (success) {
            history.push('/posts');
          }
        },
      },
    });
  };

  // Comment Test
  return (
    <Layout title="Create Post">
      <PostForm onSubmit={handleSubmit} />
    </Layout>
  );
};

export default connect(state => ({
  isWaitingSave: state.post.isWaitingSave,
}))(AddPost);
